import mitt from 'mitt';
const eventDispatcher = mitt();

export default eventDispatcher
